const URL = 'https://apis.twnel.io/';

const GOOGLE_SHEET_SERVICES = [
  {
    text: '------',
    value: '',
    method: '',
    url: '',
    params: [],
    body: '',
    headers: [],
    response: '',
  },
  {
    text: 'Save new row',
    value: 'create',
    method: 'post',
    url: `${URL}google/create_records`,
    params: [],
    body: `{
           "spreadsheetId": "YOUR_SPREADSHEET_ID",
           "range": "'Sheet1'!A1:C1000",
           "labels": ["nombre", "color", "date"],
           "data": [{
                   "nombre": "Manuela",
                   "color": "Amarillo"
               }],
           "addDate": true,
           "addDateLabel": "date",
           "locales": "es-CO",
           "formatDate": {
               "day":    "numeric",
               "month":  "numeric",
               "year":   "numeric",
               "hour":   "2-digit",
               "minute": "2-digit",
               "second": "2-digit",
               "timeZone": "America/New_York"
           },
           "msg": "Super la info se salvo"
        }
        `,
    headers: [],
    response: `
      {"type": "object",
        "properties": {
            "linesAdded": {
                "type": "number"
            },
            "msg": {
                "type": "string"
             }
        }
      }
    `,
  },
  {
    text: 'Get data',
    value: 'read',
    method: 'post',
    url: `${URL}google/get_records`,
    params: [],
    body: `{
        "spreadsheetId": "YOUR_SPREADSHEET_ID",
        "range": "'Sheet1'!A1:S1000",
        "labels": ["id", "firstname", "lastname", "phone_number", "date"],
        "query": {
            "id": [23, 654],
            "phone_number": [6175436666]
        },
     "returnOnly": "lastMatch or firstMatch  or all"   
    }`,
    headers: [],
    response: `
      {"type": "object",
      "properties": {
          
      }
    }`,

  },
  {
    text: 'Update row',
    value: 'update',
    method: 'patch',
    url: `${URL}google/update_records`,
    params: [],
    body: `{
        "spreadsheetId": "YOUR_SPREADSHEET_ID",
        "range": "'Sheet1'!A1:S1000",
        "labels": ["id", "Firstname", "Lastname", "Phone number", "date"],
        "range": "'Sheet1'!A2:E1000",
        "query": {
             "Lastname": ["Soler"],
             "id": [654]
        },
        "returnOnly": "firstMatch",
         "update": {
            "Lastname": "Garces",
            "Phone number": "+16175431212",
            "date": ""
        },
        "addDate": true,
        "addDateLabel": "date",
        "locales": "es-CO",
        "formatDate": {
            "day":    "numeric",
            "month":  "numeric",
            "year":   "numeric",
            "hour":   "2-digit",
            "minute": "2-digit",
            "second": "2-digit",
            "timeZone": "America/New_York"
        },
        "msg": "Super la info se salvo",
        "msgNoUpdate": "No se actualizó ninguna fila. Las condicones no se cumplierón"  
      }`,
    headers: [],
    response: `
    {"type": "object",
      "properties": {
          "linesAdded": {
              "type": "number"
          },
          "msg": {
              "type": "string"
           }
      }
    }
  `,
  },
  {
    text: 'Delete row',
    value: 'delete',
    method: 'delete',
    url: `${URL}google/delete_records`,
    params: [],
    body: `{
      "spreadsheetId": "YOUR_SPREADSHEET_ID",
      "sheetId": "YOUR_SHEET_ID",
      "labels": ["id", "firstname", "lastname", "phone_number", "date"],
      "range": "'Sheet1'!A2:E1000",
      "query": {
           "Lastname": ["Doe"],
           "id": [11]
      },
      "returnOnly": "firstMatch",
      "msg": "La fila que cumplió con las condiciones fue borrada",
      "msgNoUpdate": "No se actualizó ninguna fila. Las condiciones no se cumplierón"
    }`,
    headers: [],
    response: `
    {"type": "object",
      "properties": {
          "msg": {
              "type": "string"
           }  
      }
    }`,
  },
  {
    text: 'Extract text',
    value: 'ocr',
    method: 'post',
    url: `${URL}google/ocr`,
    params: [],
    body: `{
      "url": "https://cloud.google.com/static/vision/docs/images/sign_text.png",
      "breaklineCharacter": "||",
      "model": "shepard or kurzweil"
    }`,
    headers: [],
    response: `
      {"type": "object",
      "properties": {
          "text": {
            "type": "string"
          }
      }
    }`,
  },
  {
    text: 'Invoice OCR',
    value: 'invoiceOcr',
    method: 'post',
    url: `${URL}google/invoice_ocr`,
    params: [],
    body: `{
      "url": "https://cloud.google.com/static/vision/docs/images/sign_text.png",
      "schema": {
          "type": "object",
          "properties": {
            "message_type": {
              "type": "string"
            },
            "message": {
              "type": "string"
            }
          }
      },
      "model": "shepard or kurzweil"
    }`,
    headers: [],
    response: `
      {"type": "object"}
  `,
  },
  {
    text: 'Dynamic PDF',
    value: 'dynamicPDF',
    method: 'post',
    url: `${URL}google/create_pdf`,
    params: [],
    body: `{
      "templateId": "YOUR_GOOGLE_DOCS_ID",
      "folderId": "YOUR_GOOGLE_DRIVE_FOLDER_ID",
      "requests": [
          {
              "type": "text",
              "value": "Just an example!",
              "match": "TEXT TO BE REPLACED IN TEMPLATE HERE",
              "options": {
                  "bold": true,
                  "fontSize": 20
              }
          },
          {
              "type": "image",
              "value": "https://cloud.google.com/static/vision/docs/images/sign_text.png",
              "match": true
          },
          {
              "type": "table",
              "value": [
                  [
                      "HEADER 1",
                      "HEADER 2"
                  ],
                  [
                      "VALUE 1",
                      "VALUE 2"
                  ]
              ]
          }
      ]
    }`,
    headers: [],
    response: `
    {
      "type": "object",
      "properties": {
        "url": {
          "type": "string"
        }
      }
    }
    `,
  },
  {
    text: 'Send email',
    value: 'sendEmail',
    method: 'post',
    url: `${URL}google/send_email`,
    params: [],
    body: `
    {
      "text": "<p>Just an example!</p>",
      "to": ["domain@example.com"],
      "subject": "A subject test",
      "attachments": [
          {
              "path": "https://cloud.google.com/static/vision/docs/images/sign_text.png",
              "contentType": "image/png"
          }
      ],
      "useTwnelEmail": true
    }  
    `,
    headers: [],
    response: `
      {"type": "object"}
  `,
  },
];

export default GOOGLE_SHEET_SERVICES;
